// Endpoint
export const endpoints = {
    system: {
        //token: "api/token",
        antiforgery: process.env.REACT_APP_API_URL + "/system/antiforgery",
        userinfo: process.env.REACT_APP_API_URL + "/system/userinfo",
        appinfo: process.env.REACT_APP_API_URL + "/system/appinfo",
        labels: process.env.REACT_APP_API_URL + "/system/labels",
        login: process.env.REACT_APP_API_URL + "/system/login",
        logout: process.env.REACT_APP_API_URL + "/system/logout",
    },
    spareParts: {
        sites: process.env.REACT_APP_API_URL + "/spareparts/{brand}/sites",
        businessUnits:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/{customerSiteCode}/businessunits",
        getMachineById:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/machinebyid/{machineId}",
        getMachineBOMById:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/machinebom/{machineId}",
        getAssemblyItems:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/machine/{machineId}/assembly/{naturalKey}",
        currentSite:
            process.env.REACT_APP_API_URL + "/spareparts/{brand}/currentsite",
        partDetails:
            process.env.REACT_APP_API_URL +
            "/parts/partdetails/{manufacturer}/{partCode}",
        getMachines:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/{customerSiteCode}/machines",
        searchparts:
            process.env.REACT_APP_API_URL + "/spareparts/{brand}/search/parts",
        partApplicabilities:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/partapplicabilities/{manufacturer}/{partCode}",
        searchMachines:
            process.env.REACT_APP_API_URL +
            "/spareparts/{brand}/searchmachines/{value}",
        getTechnicalDocByMachineId:
            process.env.REACT_APP_API_URL +
            "/spareparts/machinedocuments/{machineId}",

        setLayoutSearch:
            process.env.REACT_APP_API_URL + "/spareparts/setLayoutSearch",
        getLayoutSearch:
            process.env.REACT_APP_API_URL + "/spareparts/getLayoutSearch",

        getMaintListByMachineId:
            process.env.REACT_APP_API_URL +
            "/spareparts/maintenancelist/{machineId}",
        getEmergListByMachineId:
            process.env.REACT_APP_API_URL +
            "/spareparts/emergencylist/{machineId}",

        getUsersToTransfer:
            process.env.REACT_APP_API_URL + "/spareparts/{brand}/customerusers",
    },
    basket: {
        baskets: process.env.REACT_APP_API_URL + "/basket/{brand}/basketlist",
        setCurrentBasket:
            process.env.REACT_APP_API_URL + "/basket/{brand}/setcurrentbasket",
        basketDetails:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/basketdetails/{getPrice}",
        cachedBasketDetails:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/basketdetailscached",
        createBasket: process.env.REACT_APP_API_URL + "/basket/{brand}/create",
        renameBasket: process.env.REACT_APP_API_URL + "/basket/{brand}/rename",
        deleteBasket: process.env.REACT_APP_API_URL + "/basket/{brand}/delete",
        mergeBasket:
            process.env.REACT_APP_API_URL + "/basket/{brand}/mergeBasket",
        addBasketItem: process.env.REACT_APP_API_URL + "/basket/basketitem/add",
        addBasketItems:
            process.env.REACT_APP_API_URL + "/basket/basketitem/items/add",
        updateBasketItem:
            process.env.REACT_APP_API_URL + "/basket/{brand}/basketitem/update",
        updateBasketItemNavContext:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/basketitem/updateNavContext/{forAllPart}",
        deleteBasketItem:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/basketitem/delete/{itemId}",

        checkItemsForUpload:
            process.env.REACT_APP_API_URL +
            "/parts/{brand}/checkItemsForUpload",
        uploadBasket:
            process.env.REACT_APP_API_URL + "/basket/{brand}/uploadBasket",

        uploadBasketSendReport:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/uploadBasketSendReport",

        checkBasketName:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/basketitem/checkBasketName",

        clearBasket:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/basketitem/deleteAll",

        transferBasket:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/transfer/{username}",

        getPartsByRef:
            process.env.REACT_APP_API_URL +
            "/basket/{brand}/getPartsByReference",

        getAvailability:
            process.env.REACT_APP_API_URL + "/parts/{brand}/getAvailability",
    },
    warranty: {
        getItems: process.env.REACT_APP_API_URL + "/warranty/{brand}/items",
        createOrderWarranty:
            process.env.REACT_APP_API_URL +
            "/warranty/{brand}/createorderwarranty",
    },
    orderoffer: {
        getInvoicesAddress:
            process.env.REACT_APP_API_URL +
            "/orderoffer/{brand}/invoicesaddress",
        getShipToAddress:
            process.env.REACT_APP_API_URL + "/orderoffer/{brand}/shiptoaddress",
        checkOrderOfferReference:
            process.env.REACT_APP_API_URL +
            "/orderoffer/{brand}/checkpon/{orderoffer}/{pon}",
        salesConditions:
            process.env.REACT_APP_API_URL +
            "/orderoffer/{brand}/salesConditions",
        sendOffer:
            process.env.REACT_APP_API_URL + "/orderoffer/{brand}/createoffer",
        sendOrder:
            process.env.REACT_APP_API_URL + "/orderoffer/{brand}/createorder",
        sendOrderFromOffer:
            process.env.REACT_APP_API_URL +
            "/orderoffer/{brand}/createOrderFromOffer",

        getOfferHistory:
            process.env.REACT_APP_API_URL + "/orderoffer/getOfferHistory",
        getOrderHistory:
            process.env.REACT_APP_API_URL + "/orderoffer/getOrderHistory",
        getOfferDetails:
            process.env.REACT_APP_API_URL + "/orderoffer/getOfferDetail",
        getOfferPdf: process.env.REACT_APP_API_URL + "/orderoffer/getOfferPdf",
        getOrderDetails:
            process.env.REACT_APP_API_URL + "/orderoffer/getOrderDetail",
        getOrderPdf: process.env.REACT_APP_API_URL + "/orderoffer/getOrderPdf",
        getOrderShippingDocuments:
            process.env.REACT_APP_API_URL +
            "/orderoffer/getOrderShippingDocuments",
    },
};
